// extracted by mini-css-extract-plugin
module.exports = {"NewsList":"NewsList_NewsList__TDJrW","NewsListItem":"NewsList_NewsListItem__66hUb","NoArticles":"NewsList_NoArticles__a8zzL"};